import React, { useState } from 'react'
import { connect, DispatchProp } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { CAlert, CCard, CCardBody, CCol, CContainer, CRow, CSpinner, } from '@coreui/react'
import { CreateErrorNotice } from '../../store/actions/toaster.action';
import { Verify } from '../actions/verify.action';
import AuthUtils from '../../shared/utils/auth-utils';
import { RootState } from '../../store/state';

interface VerifyPageProps extends DispatchProp {
  errorText: string;
  isLoading: boolean;
}

const VerifyPage = (props: VerifyPageProps) => {
  const { dispatch, errorText, isLoading } = props;
  const [willRedirect, setWillRedirect] = useState(false);
  const history = useHistory();

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    if (!params.has('code')) {
      dispatch(new CreateErrorNotice('Error', "A verification code is required."));
      history.push('/login');
      return;
    }

    dispatch(new Verify({ code: params.get('code') }, true));
  }, []);

  React.useEffect(() => {
    if (errorText && errorText.includes("link has expired")) {
      setWillRedirect(true);
      setTimeout(() => {
        history.push('/register');
      }, 3000);
    }
  }, [errorText])

  return (
    <>
      { AuthUtils.isAuth() && (<Redirect to="/account-verified" />)}
      { !AuthUtils.isAuth() && (
      <div className="c-app c-default-layout flex-row align-items-center">
        <CContainer>
          <CRow className="justify-content-center">
            <CCol xl="3" lg="6" md="8">
              <CCard className="p-4">
                <CCardBody className="text-center">
                  <h3>Verifying</h3>
                  { (isLoading || willRedirect) && <CSpinner size="lg" className="mt-3 primary-color" /> }
                </CCardBody>
              </CCard>
              {
                (errorText && !isLoading) ? (
                  <CAlert className="my-10" color="warning" fade>{ errorText }</CAlert>
                ) : null
              }
            </CCol>
          </CRow>
        </CContainer>
      </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  errorText: state?.orgManagement?.verify?.errorText,
  isLoading: state?.orgManagement?.verify?.isLoading,
});

export default connect(mapStateToProps)(VerifyPage);
